;(function () {
  'use strict'

  angular.module('admin.all_sales.service', []).factory('AllSalesService', AllSalesService)

  /** @ngInject */
  function AllSalesService($http, $q, API) {
    function getChannels() {
      var defered = $q.defer()
      $http
        .get(API.API_URL + 'publisher/channels')
        .success(function (res) {
          var channels = res.results ? res.results : res
          defered.resolve(channels)
        })
        .error(defered.reject)
      return defered.promise
    }

    function buildParams(start, limit, filters) {
      var params = {}
      if (start !== undefined) params.start = start
      if (limit !== undefined) params.limit = limit

      if (filters) {
        if (filters.startDate) params['start-date'] = filters.startDate
        if (filters.endDate) params['end-date'] = filters.endDate
        if (filters.channels && filters.channels.length > 0) {
          params.ch_id = filters.channels
            .map(function (c) {
              return c.id || c
            })
            .join(',')
        }
        if (filters.bundleId) params.b_id = filters.bundleId
        if (filters.transactionType !== undefined && filters.transactionType !== 'all') {
          params.store = filters.transactionType
        }
        if (filters.transactionStatus !== undefined && filters.transactionStatus !== 'all') {
          params.status = filters.transactionStatus
        }
      }
      return params
    }

    function list(start, limit, filters) {
      var defered = $q.defer()
      var params = buildParams(start, limit, filters)

      $http
        .get(API.API_URL + 'admin/purchase_logs', { params: params })
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function exportTransactions(filters, selectedFields) {
      var defered = $q.defer()
      var params = buildParams(undefined, undefined, filters)

      if (selectedFields && selectedFields.length > 0) {
        params.fields = selectedFields.join(',')
      }

      $http
        .get(API.API_URL + 'admin/purchase_logs/export', { params: params })
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function getAnalytics(range, channels) {
      var defered = $q.defer()
      var params = { range: range }
      if (channels) {
        if (angular.isArray(channels)) {
          if (channels.length > 0) {
            params.ch = channels.join(',')
          }
        } else {
          params.ch = channels
        }
      }

      $http
        .get(API.API_URL + 'admin/users/analytics', { params: params })
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function getAccounting(startDate, endDate, channels) {
      var defered = $q.defer()
      var params = {}
      if (startDate) params['start-date'] = startDate
      if (endDate) params['end-date'] = endDate
      if (channels && channels.length > 0) {
        params.ch = channels
          .map(function (c) {
            return c.id || c
          })
          .join(',')
      }

      $http
        .get(API.API_URL + 'admin/users/accounting', { params: params })
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function exportAccounting(startDate, endDate, channels) {
      var defered = $q.defer()
      var params = {}
      if (startDate) params['start-date'] = startDate
      if (endDate) params['end-date'] = endDate
      if (channels && channels.length > 0) {
        params.ch = channels
          .map(function (c) {
            return c.id || c
          })
          .join(',')
      }

      $http
        .get(API.API_URL + 'admin/users/accounting?export=csv', {
          params: params,
          responseType: 'arraybuffer',
        })
        .then(
          function (res) {
            defered.resolve(res)
          },
          function (err) {
            defered.reject(err)
          },
        )

      return defered.promise
    }

    function exportAnalytics(range, channels, format) {
      var defered = $q.defer()
      var params = { range: range, export: format }
      if (channels) {
        if (angular.isArray(channels)) {
          if (channels.length > 0) {
            params.ch = channels.join(',')
          }
        } else {
          params.ch = channels
        }
      }

      $http
        .get(API.API_URL + 'admin/users/analytics', { params: params, responseType: 'arraybuffer' })
        .then(
          function (res) {
            defered.resolve(res)
          },
          function (err) {
            defered.reject(err)
          },
        )

      return defered.promise
    }

    return {
      list: list,
      getChannels: getChannels,
      exportTransactions: exportTransactions,
      getAnalytics: getAnalytics,
      getAccounting: getAccounting,
      exportAccounting: exportAccounting,
      exportAnalytics: exportAnalytics,
    }
  }
})()
